import { IProductFinderL10n } from "../../../types/l10n";
import { IPromotion } from "../../../types/suggestion-items";

export default function mapProductFinderL10nToPromotion(
    productFinderL10n: IProductFinderL10n
): Record<string, IPromotion> {
    return {
        trouserfinder: {
            name: "TrouserFinder",
            logoUrl: productFinderL10n.trouserFinderLogo,
            headline: productFinderL10n.trouserFinderHeadline,
            cta: productFinderL10n.trouserFinderCTA,
            link: productFinderL10n.trouserFinderLink,
            shortLink: productFinderL10n.trouserFinderShortLink,
            productFinderLogoBasePathPreview: productFinderL10n.productFinderLogoBasePathPreview,
            productFinderLogoBasePathRelease: productFinderL10n.productFinderLogoBasePathRelease,
            navIndex: 0
        },
        jacketfinder: {
            name: "JacketFinder",
            logoUrl: productFinderL10n.jacketFinderLogo,
            headline: productFinderL10n.jacketFinderHeadline,
            cta: productFinderL10n.jacketFinderCTA,
            link: productFinderL10n.jacketFinderLink,
            shortLink: productFinderL10n.jacketFinderShortLink,
            productFinderLogoBasePathPreview: productFinderL10n.productFinderLogoBasePathPreview,
            productFinderLogoBasePathRelease: productFinderL10n.productFinderLogoBasePathRelease,
            navIndex: 0
        },
        shoefinder: {
            name: "ShoeFinder",
            logoUrl: productFinderL10n.shoeFinderLogo,
            headline: productFinderL10n.shoeFinderHeadline,
            cta: productFinderL10n.shoeFinderCTA,
            link: productFinderL10n.shoeFinderLink,
            shortLink: productFinderL10n.shoeFinderShortLink,
            productFinderLogoBasePathPreview: productFinderL10n.productFinderLogoBasePathPreview,
            productFinderLogoBasePathRelease: productFinderL10n.productFinderLogoBasePathRelease,
            navIndex: 0
        }
    };
}
